import {Message} from 'element-ui'
import i18n from '@/lang'

/*************** 定义公共的属性和方法 **********************/

/**
 * 是否为外部链接
 * @param path
 * @returns {boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 拼接动态排序字段(用于ElementUI Table控件)
 * @param column
 * @returns {*}
 */
export function buildSortStr(column) {
    // 转换为标准的排序方式
    let buildOrder = function (order) {
        return order === 'descending' ? 'desc' : 'asc';
    }
    // 排序默认为空
    let sortStr = null;
    if (column.prop) {
        sortStr = column.prop + ":" + buildOrder(column.order);
    }
    return sortStr;
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
    if (document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false)
            }
        }
    } else {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
    if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false)
            }
        }
    } else {
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * 复制内容到粘贴板
 * content : 需要复制的内容
 * message : 复制完后的提示，默认提示"已复制到剪贴板中"
 */
export function copy2Clip(content, message) {
    let aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    Message({
        message: message || i18n.t('message.copySuccess'),
        type: 'success',
        duration: 3 * 1000
    })
}

/**
 * 获取URL参数
 * paramName : 参数名称
 */
export function getQueryParam(paramName) {
    let reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}
